<template>
  <div
    v-show="status"
    :class="['status-message', 'card-panel', 'white-text', color]"
  >
    {{ message }}
  </div>
</template>

<style>
.status-message {
  position: fixed;
  bottom: 15px;
  right: 15px;
  min-width: 300px;
  text-align: center;
  z-index: 1050;
}
</style>

<script>
import { mapMutations } from 'vuex'

export default {
  name: 'StatusMessage',

  // Accept these props from parent component
  props: ['status', 'color', 'message'],

  methods: {
    ...mapMutations(['HIDE_STATUS_MESSAGE']),

    // Mutation to close snackbar
    closeSnackbar () {
      this.$store.commit('HIDE_STATUS_MESSAGE')
    }
  }
}
</script>
